// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card-title-container-7u6S4 {
  padding: 16px 20px 8px;
}

.product-card-title-title-_SS93 {
  flex-shrink: 0;
  font-size: 17px;
  font-weight: 500;
  color: rgb(0 0 0 / 0.8);
}

.product-card-title-transition-LGF5Y {
  width: 100px;
  color: transparent;
  background-color: var(--color-neutral-200);
  border-radius: var(--radius-sm);
  animation: product-card-title-pulse-Yj4YJ 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes product-card-title-pulse-Yj4YJ {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/product-card/product-card-title/product-card-title.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,kFAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  padding: 16px 20px 8px;\n}\n\n.title {\n  flex-shrink: 0;\n  font-size: 17px;\n  font-weight: 500;\n  color: rgb(0 0 0 / 0.8);\n}\n\n.transition {\n  width: 100px;\n  color: transparent;\n  background-color: var(--color-neutral-200);\n  border-radius: var(--radius-sm);\n  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product-card-title-container-7u6S4`,
	"title": `product-card-title-title-_SS93`,
	"transition": `product-card-title-transition-LGF5Y`,
	"pulse": `product-card-title-pulse-Yj4YJ`
};
export default ___CSS_LOADER_EXPORT___;
